// SEO copy per language. Primary audience: Ukrainian community in Brno / Czech Republic.
// Keywords are intentionally exhaustive (Yandex / Seznam still weight them; Google ignores
// but doesn't penalize). Real, search-realistic phrases — not gibberish.

const COMMON_KEYWORDS_UK = [
  // Ukrainian community core terms
  "іпотека Чехія",
  "іпотека Брно",
  "іпотека для українців",
  "іпотека для українців у Чехії",
  "іпотечний радник Брно",
  "іпотечний консультант українською",
  "іпотечний брокер Брно",
  "український іпотечний радник",
  "українські фінансові консультанти Чехія",
  "купити житло в Чехії",
  "купити квартиру в Чехії",
  "придбання нерухомості в Чехії",
  "кредит на житло Чехія",
  "кредит на нерухомість Чехія",
  "рефінансування іпотеки Чехія",
  "рефінансування іпотеки Брно",
  "консультація з іпотеки безкоштовно",
  "іпотека для іноземців Чехія",
  "іпотека для іноземців Брно",
  "іпотека без знання чеської",
  "перше житло Чехія",
  "перше житло Брно",
  "інвестиційна нерухомість Чехія",
  "інвестиційна нерухомість Брно",
  "комерційний кредит Чехія",
  "комерційні кредити Брно",
  "приватне фінансове консультування Брно",
  "приватний банкінг Чехія",
  "ставки по іпотеці Чехія 2026",
  "найкраща іпотека 2026",
  "порівняння іпотек Чехія",
  "ЧНБ іпотечні ставки",
  "DBR Invest",
  "dbrinvest.cz",
  "DBR Invest a.s.",
  "Brno іпотека українською",
  "Брно іпотека",
  "допомога з іпотекою для українців",
  "як отримати іпотеку в Чехії",
  "оформлення іпотеки Чехія",
  "консультант з нерухомості Брно",
  "ріелтор українською Брно",
  "ріелтор Чехія українською",
  "переїзд до Чехії іпотека",
  "купівля квартири Брно для іноземця",
  "вид на проживання іпотека Чехія",
  "trvalý pobyt іпотека",
  "fixace іпотека Чехія",
  "LTV Чехія",
];

const COMMON_KEYWORDS_CS = [
  "hypotéka Brno",
  "hypoteční poradce Brno",
  "hypoteční specialista Brno",
  "hypoteční poradenství Brno",
  "nezávislý hypoteční poradce",
  "refinancování hypotéky Brno",
  "refinancování hypotéky 2026",
  "první bydlení hypotéka",
  "investiční hypotéka Brno",
  "komerční úvěr Brno",
  "komerční financování Brno",
  "hypotéka pro cizince",
  "hypotéka pro Ukrajince",
  "hypotéka pro mladé do 36",
  "realitní poradenství Brno",
  "srovnání hypoték 2026",
  "nejlepší hypotéka 2026",
  "hypoteční sazby ČNB",
  "hypoteční kalkulačka",
  "konzultace hypotéky zdarma",
  "jak získat hypotéku",
  "hypotéka bez papírování",
  "hypoteční broker Brno",
  "privátní finanční poradenství",
  "DBR Invest",
  "DBR Invest a.s.",
  "dbrinvest.cz",
  "fixace hypotéky 5 let",
  "refix hypotéky Brno",
  "úvěr na bydlení",
  "úvěr na nemovitost",
  "hypotéka pro investory",
  "hypotéka více nemovitostí",
];

const COMMON_KEYWORDS_EN = [
  "mortgage Brno",
  "mortgage Czech Republic",
  "mortgage advisor Brno",
  "mortgage broker Brno",
  "mortgage consultant Brno",
  "independent mortgage broker Czech Republic",
  "mortgage for foreigners Czech Republic",
  "mortgage for Ukrainians Czech Republic",
  "Ukrainian mortgage advisor Brno",
  "real estate advisory Brno",
  "refinancing Czech Republic",
  "first-time home buyer Brno",
  "investment mortgage Brno",
  "commercial loan Brno",
  "buy property Czech Republic",
  "buy apartment Brno",
  "mortgage rates Czech Republic 2026",
  "best mortgage Czech Republic",
  "Czech National Bank mortgage rates",
  "private banking Brno",
  "expat mortgage Brno",
  "foreigner mortgage Czech Republic",
  "DBR Invest",
  "DBR Invest a.s.",
  "dbrinvest.cz",
];

export const SEO_DATA = {
  cs: {
    lang: "cs-CZ",
    title:
      "DBR Invest — Hypoteční poradenství Brno | Srovnání sazeb 10+ bank | dbrinvest.cz",
    description:
      "Nezávislý hypoteční poradce v Brně. Srovnáváme sazby napříč všemi bankami pro první bydlení, refinancování i komerční financování. Konzultace zdarma — i pro cizince a Ukrajince. DBR Invest a.s.",
    keywords: COMMON_KEYWORDS_CS.join(", "),
    og_locale: "cs_CZ",
    og_title:
      "DBR Invest — Hypoteční poradenství Brno",
    og_description:
      "Hypotéka bez stresu a papírování. Srovnání 10+ bank, refinancování, investiční a komerční úvěry. Konzultace zdarma.",
  },
  uk: {
    lang: "uk-UA",
    title:
      "DBR Invest — Іпотечний радник у Брно | Іпотека для українців у Чехії | dbrinvest.cz",
    description:
      "Незалежний іпотечний радник у Брно — консультація українською. Порівняємо ставки 10+ банків для першого житла, рефінансування, інвестицій і комерційного фінансування. Безкоштовна консультація для українців у Чехії.",
    keywords: COMMON_KEYWORDS_UK.join(", "),
    og_locale: "uk_UA",
    og_title:
      "DBR Invest — Іпотека в Чехії українською | Брно",
    og_description:
      "Іпотека без стресу і паперової тяганини. Порівняння 10+ банків, рефінансування, інвестиційні та комерційні кредити. Консультація українською безкоштовно.",
  },
  en: {
    lang: "en",
    title:
      "DBR Invest — Mortgage Advisor in Brno | Czech Mortgages for Foreigners | dbrinvest.cz",
    description:
      "Independent mortgage broker in Brno, Czech Republic. We compare rates across 10+ banks for first-time buyers, refinancing, investment property and commercial financing. Free consultation, foreigner-friendly.",
    keywords: COMMON_KEYWORDS_EN.join(", "),
    og_locale: "en_US",
    og_title:
      "DBR Invest — Mortgage Advisor in Brno, Czech Republic",
    og_description:
      "Mortgages without stress or paperwork. 10+ banks compared, refinancing, investment and commercial loans. Free consultation, foreigner-friendly.",
  },
};

export const SITE_URL = "https://dbrinvest.cz";
export const SITE_LOGO = `${SITE_URL}/logo-dbr-invest.png`;

export const buildLocalBusinessJsonLd = (lang) => {
  const data = SEO_DATA[lang] || SEO_DATA.cs;
  return {
    "@context": "https://schema.org",
    "@type": "FinancialService",
    "@id": `${SITE_URL}#business`,
    name: "DBR Invest a.s.",
    alternateName: ["DBR Invest", "dbrinvest.cz"],
    url: SITE_URL,
    logo: SITE_LOGO,
    image: SITE_LOGO,
    description: data.description,
    inLanguage: ["cs", "uk", "en"],
    areaServed: [
      { "@type": "AdministrativeArea", name: "Brno" },
      { "@type": "AdministrativeArea", name: "Jihomoravský kraj" },
      { "@type": "Country", name: "Česká republika" },
    ],
    address: {
      "@type": "PostalAddress",
      streetAddress: "Banskobystrická 265/185",
      addressLocality: "Brno",
      postalCode: "621 00",
      addressCountry: "CZ",
    },
    telephone: "+420774452773",
    email: "dbrinvest@email.cz",
    priceRange: "Konzultace zdarma",
    serviceType: [
      "Hypoteční poradenství",
      "Refinancování hypoték",
      "Investiční financování",
      "Komerční úvěry",
      "Privátní poradenství",
      "Іпотечне консультування",
      "Mortgage advisory",
    ],
    knowsLanguage: [
      { "@type": "Language", name: "Czech", alternateName: "cs" },
      { "@type": "Language", name: "Ukrainian", alternateName: "uk" },
      { "@type": "Language", name: "English", alternateName: "en" },
    ],
    sameAs: [],
  };
};
